import React, { useEffect, useState } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { Grid, TextField } from '@material-ui/core';
import { resolveSagisClaim } from 'helpers/utils';
import { arrayTranslate, translate } from 'containers/services/translate';
import messages from 'containers/common/LegalProceedings/ExpertReport/FormsByExpertiseType/messages';
import {
  ExpertReportType,
  IVehiculeExpertise,
} from 'containers/common/LegalProceedings/ExpertReport/typings';
import {
  EMPTY_DOCUMENT,
  VEHICULE_EXPERTISE_FIELDS,
} from 'containers/data-structure';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import { get, isEmpty, isNil } from 'lodash';
import UploadDocumentBloc from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/UploadDocumentBloc';
import { DOCUMENT_TYPES } from 'constants/global';
import { getDocumentId } from 'containers/common/LegalProceedings/ExpertReport/utils';
import { Listings } from 'containers/AppContainer/typings';
import ExpertReportDecision from 'containers/CourtManagerLegalProceedings/ExpertReport/Decision';
import { CorporealDocument } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import { mechanicalExpertisesValidator } from 'containers/ExpertExpertise/ConcernedExpertise/utils';
import { displayErrorText } from 'containers/services/validateForm';
import userPrivileges, {
  PRIVILEGES,
} from 'containers/services/security/user-privileges';
import { showUpdateButton } from 'containers/common/LegalProceedings/ExpertReport/FormsByExpertiseType/utils';
import { TYPE } from 'containers/common/LegalProceedings/ExpertReport/FormsByExpertiseType/constants';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import ImportImagineDocumentButton from 'containers/CourtManagerLegalProceedings/ImagineDocuments/ImportButton';
export interface MechanicalExpertiseProps {
  intl: IntlShape;
  listings: Listings;
  vehiculeExpertReport: IVehiculeExpertise;
  setVehiculeExpertReport: Function;
  uploadDocument: Function;
  uploadedDocument: IUploadedDocument;
  resetUploadedDocument: Function;
  expertiseJudgementAddDocumentId?: string;
  setDocumentId: Function;
  setDocument: Function;
  documentIndex: number;
  isManager?: boolean;
  setIsDecisionDialgOpen?: Function;
  readOnly?: boolean;
  isDecisionDialgOpen?: boolean;
  isRejected?: boolean;
  documentId?: string;
  isAppeal?: boolean;
  isRecap?: boolean;
  isAssignedLawyer: boolean;
  isExpertReportValidated: boolean;
  username: string;
  isLawyerAssignedJudiciary?: boolean;
  expertReportState: ExpertReportType;
  imagineDocuments: any;
  claimId: number;
  policyInfo: any;
  requestGetDocByDocumentumId: Function;
}

export const MechanicalExpertise: React.FC<MechanicalExpertiseProps> = ({
  vehiculeExpertReport,
  isAppeal,
  ...props
}): JSX.Element => {
  const translateArrayErrorMessages = arrayTranslate(props.intl.formatMessage);
  const validateMechanical = mechanicalExpertisesValidator(
    get(vehiculeExpertReport, 'vehiculeExpertise'),
  );

  const { message } =
    displayErrorText(
      validateMechanical,
      translateArrayErrorMessages(validateMechanical, true),
    ) || {};

  const handleChange = (e: React.ChangeEvent<{ value: string }>) => {
    const vehExpertReport = { ...vehiculeExpertReport };

    vehExpertReport.vehiculeExpertise[
      VEHICULE_EXPERTISE_FIELDS.DAMAGE_AMOUNT
    ] = e.target.value.replace(',', '.');

    props.setVehiculeExpertReport(vehExpertReport);
  };

  const [expertReportDocument, setExpertReportDocument] = useState({
    ...EMPTY_DOCUMENT,
  });

  const [oldExpertReportDocument, setOldExpertReportDocument] = useState({
    ...EMPTY_DOCUMENT,
  });

  /* istanbul ignore next */
  const setExpertReportDoc = (document: CorporealDocument) => {
    const vehExpertReport = { ...vehiculeExpertReport };
    if (
      getDocumentId(
        String(vehiculeExpertReport.id) as string,
        props.expertiseJudgementAddDocumentId as string,
      ) === props.documentId
    ) {
      vehExpertReport.vehiculeExpertise[
        VEHICULE_EXPERTISE_FIELDS.VEHICULE_EXPERTISE_DOCUMENTS
      ] = [{ ...document, id: get(oldExpertReportDocument, 'id', null) }];

      setExpertReportDocument(document as any);
      props.setVehiculeExpertReport(vehExpertReport);
      props.resetUploadedDocument();
    }
  };

  /* istanbul ignore next */
  useEffect(() => {
    setOldExpertReportDocument(
      get(
        vehiculeExpertReport.vehiculeExpertise,
        [VEHICULE_EXPERTISE_FIELDS.VEHICULE_EXPERTISE_DOCUMENTS, '0'],
        {},
      ),
    );
  }, [vehiculeExpertReport]);

  return (
    <div className="global-expertise-container">
      <div className="mechanical-wrapper">
        <div className="mechanical-form">
          <TextField
            label={translate(messages.damageAmount, props)}
            name={VEHICULE_EXPERTISE_FIELDS.DAMAGE_AMOUNT}
            value={get(
              vehiculeExpertReport.vehiculeExpertise,
              VEHICULE_EXPERTISE_FIELDS.DAMAGE_AMOUNT,
              '',
            )}
            type="number"
            onChange={handleChange}
            InputProps={{ disabled: props.readOnly }}
            error={message[VEHICULE_EXPERTISE_FIELDS.DAMAGE_AMOUNT]}
            helperText={message[VEHICULE_EXPERTISE_FIELDS.DAMAGE_AMOUNT]}
            className="mechanical-item-field"
          />{' '}
          <Grid container direction="column">
            <Grid item xs={5}>
              <Grid container direction="row" spacing={2}>
                <Grid item xs>
                  <UploadDocumentBloc
                    document={oldExpertReportDocument}
                    setDocument={props.setDocument}
                    uploadDocument={props.uploadDocument}
                    uploadedDocument={props.uploadedDocument}
                    resetUploadedDocument={props.resetUploadedDocument}
                    docType={
                      !isAppeal
                        ? DOCUMENT_TYPES.EXPERT_REPORT
                        : DOCUMENT_TYPES.EXPERT_REPORT_APPEAL
                    }
                    index={props.documentIndex}
                    docId={getDocumentId(
                      String(vehiculeExpertReport.id) as string,
                      props.expertiseJudgementAddDocumentId as string,
                    )}
                    setDocumentId={props.setDocumentId}
                    shouldDisplay={false}
                  />
                </Grid>
                <Grid item style={{ marginTop: '20px' }}>
                  {!isEmpty(props.imagineDocuments) &&
                    props.isManager &&
                    isNil(
                      get(vehiculeExpertReport.vehiculeExpertise, 'id', null),
                    ) &&
                    featureService.hasFeature(
                      FEATURES.TRAITEMENT_IMAGINE_DOC,
                    ) && (
                      <ImportImagineDocumentButton
                        listings={props.listings}
                        managerNotifcationsInboxes={props.imagineDocuments}
                        claimId={props.claimId}
                        imagineDocuments={props.imagineDocuments}
                        claimSagisInfo={resolveSagisClaim(props.policyInfo)}
                        uploadDocument={props.uploadDocument}
                        uploadedDocument={props.uploadedDocument}
                        setUploadedDocs={props.setDocument}
                        documentName={
                          !isAppeal
                            ? DOCUMENT_TYPES.EXPERT_REPORT
                            : DOCUMENT_TYPES.EXPERT_REPORT_APPEAL
                        }
                        documentType={
                          !isAppeal
                            ? DOCUMENT_TYPES.EXPERT_REPORT
                            : DOCUMENT_TYPES.EXPERT_REPORT_APPEAL
                        }
                        documentId={getDocumentId(
                          String(vehiculeExpertReport.id) as string,
                          props.expertiseJudgementAddDocumentId as string,
                        )}
                        setDocumentId={props.setDocumentId}
                        requestGetDocByDocumentumId={
                          props.requestGetDocByDocumentumId
                        }
                      />
                    )}
                </Grid>
              </Grid>
            </Grid>
            {((props.isRejected &&
              (!isEmpty(
                get(vehiculeExpertReport.vehiculeExpertise, 'creator', ''),
              )
                ? get(vehiculeExpertReport.vehiculeExpertise, 'creator', '') ===
                  props.username
                : props.isAssignedLawyer)) ||
              showUpdateButton(
                props.expertReportState,
                TYPE.VEHICLE,
                get(vehiculeExpertReport, 'vehiculeExpertise', {}),
                props.isManager,
              )) && (
              <Grid item xs={5}>
                <div className="add-recap-bloc-title">
                  {translate(messages.newDocument, props)}
                </div>
                <UploadDocumentBloc
                  document={expertReportDocument}
                  setDocument={setExpertReportDoc}
                  uploadDocument={props.uploadDocument}
                  uploadedDocument={props.uploadedDocument}
                  resetUploadedDocument={props.resetUploadedDocument}
                  docType={
                    !isAppeal
                      ? DOCUMENT_TYPES.EXPERT_REPORT
                      : DOCUMENT_TYPES.EXPERT_REPORT_APPEAL
                  }
                  index={props.documentIndex}
                  docId={getDocumentId(
                    String(vehiculeExpertReport.id) as string,
                    props.expertiseJudgementAddDocumentId as string,
                  )}
                  setDocumentId={props.setDocumentId}
                  shouldDisplay={false}
                />
              </Grid>
            )}
          </Grid>
        </div>
        <Grid container direction="row">
          {get(vehiculeExpertReport, 'vehiculeExpertise.isOld') && (
            <Grid item xs={6} className="caduc-position">
              <article className="caduc-item">
                {translate(messages.deprecated, props)}
              </article>
            </Grid>
          )}

          {(featureService.hasFeature(FEATURES.EVOLUTION_P1)
            ? true
            : !get(vehiculeExpertReport, 'vehiculeExpertise.isOld')) &&
            (props.isLawyerAssignedJudiciary ||
              props.isManager ||
              userPrivileges.userHasPrivilege(
                PRIVILEGES.ISCOURTMONITORINGMANAGER,
              )) && (
              <Grid item xs={2}>
                <section className="expert-report-decision-wrapper">
                  {get(
                    vehiculeExpertReport,
                    'vehiculeExpertise.creator',
                    '',
                  ) && (
                    <span
                      style={{
                        fontWeight: 'bold',
                        fontSize: '12px',
                        color: '#0072c6',
                      }}
                    >
                      {translate(messages.creatorTitle, props, {
                        lawyer: get(
                          vehiculeExpertReport,
                          'vehiculeExpertise.creator',
                          '',
                        ),
                      })}
                    </span>
                  )}
                </section>
                <ExpertReportDecision
                  expertise={vehiculeExpertReport as IVehiculeExpertise}
                  setExpertise={props.setVehiculeExpertReport}
                  uploadDocument={props.uploadDocument}
                  uploadedDocument={props.uploadedDocument}
                  resetUploadedDocument={props.resetUploadedDocument}
                  setIsDecisionDialgOpen={
                    props.setIsDecisionDialgOpen as Function
                  }
                  isDecisionDialgOpen={props.isDecisionDialgOpen as boolean}
                  isManager={props.isManager as boolean}
                  isExpertReportValidated={props.isExpertReportValidated}
                  expertReportState={props.expertReportState}
                  requestGetDocByDocumentumId={
                    props.requestGetDocByDocumentumId
                  }
                />
              </Grid>
            )}
        </Grid>
      </div>
    </div>
  );
};

MechanicalExpertise.defaultProps = {
  readOnly: false,
};

export default injectIntl(MechanicalExpertise);
